import { render, staticRenderFns } from "./FooterNavSocial.vue?vue&type=template&id=654d260f&"
import script from "./FooterNavSocial.vue?vue&type=script&lang=js&"
export * from "./FooterNavSocial.vue?vue&type=script&lang=js&"
import style0 from "./FooterNavSocial.vue?vue&type=style&index=0&id=654d260f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports